export default "__VITE_ASSET__BGeCNvJJ__"